import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Col, Row } from 'react-bootstrap';
import { useParams, Link, useLocation, useHistory } from 'react-router-dom';
import AddEditDAMComponent from './AddEditDAMComponent';
import {
  customStylesProductAddEdit,
  assetType,
  extractS3KeyName,
  includesAnyVideoUrlLink,
  getProgressedVideoProperties,
  checkArray,
} from '../../../Components/helper';
import { useDAMAddEditModuleState } from './Provider/index';
import * as colourAction from '../../Library/ColorLibary/store/ColorLibrary.action';
import * as dam from '../store/DAM.action';
import * as sysAction from '../../SystemMasters/Store/SystemMasters.action';
import Loader from '../../../Components/Utility/Loader/Loader';
import * as uploaderAction from '../../UploaderRedux/store/uploader.action';
import { toasterMsg } from '../../../Components/Toaster/Toaster';
import * as productDam from '../../DevlopmentOrder/Dam/DamFiles/store/DamFile.action';

const imageLiteral = 'data:image';
const videoLiteral = 'data:video';
function AddEditDAM() {
  const { DamAddeditstate, setAddEditDAMState } = useDAMAddEditModuleState();
  const { t } = useTranslation('common');
  const location = useLocation();
  const isDuplicate = location.pathname.includes('duplicate');
  const reducer = useSelector((reducerstate) => reducerstate);
  const { damId, devOrderId } = useParams();
  const [errors, setErrors] = useState([]);
  const { dam: damData, loader } = DamAddeditstate;
  const isDuplicateFile = location?.state?.isDuplicate || false;
  const isFolderDragDrop = location?.state?.isFolderDragDrop || false;
  const history = useHistory();
  const dispatch = useDispatch();
  const { UserDetails } = reducer;
  const [stateLoader, setLoader] = useState(false);
  const { userInfo } = UserDetails;
  useEffect(() => {
    if (userInfo?.userId) {
      dispatch(
        colourAction.fetchColorListLibrary({
          loggedInUserId: userInfo?.userId,
        }),
      );
    }
  }, [dispatch, userInfo?.userId]);
  console.log('isFolderDragDropisFolderDragDrop', isFolderDragDrop);
  useEffect(() => {
    dispatch(sysAction.getDamAttributeFreeText({ type: 'dropdown' }));
    dispatch(sysAction.getDamAttributeFreeText({ type: 'text' }));
  }, [dispatch]);

  const selectAssetType = (selectedOption) => {
    const cloneDam = [...DamAddeditstate.dam];
    const updatedDam = cloneDam.map((item) => ({
      ...item,
      assetType: selectedOption,
    }));
    setAddEditDAMState((prev) => ({
      ...prev,
      dam: updatedDam,
    }));
  };

  const fetchOptions = () => {
    dispatch(dam.fetchDamProductList());
  };

  useEffect(() => {
    fetchOptions();
  }, []);

  const getAssetImageType = (assey) => !!['imageLink'].includes(assey?.value);
  const getAssetVideoType = (assey) => !!['videoLink'].includes(assey?.value);

  const validationFun = async (linkInvalid, index = null) => {
    const newErrors = [];
    let hasError = false;
    const linkMsg = 'Link is not valid';
    const validateEntry = async (val, i) => {
      const isImageLink = getAssetImageType(val?.assetType);
      const isVideoLink = getAssetVideoType(val?.assetType);
      const error = {};
      const assetTitles = val?.assetTitle;
      if (linkInvalid && isImageLink) {
        error.imageLink = linkMsg;
        hasError = true;
      }
      if (linkInvalid && isVideoLink) {
        error.videoLink = linkMsg;
        hasError = true;
      }
      if (!assetTitles) {
        hasError = true;
        error.assetTitle = 'Asset Title is required';
      }
      if (isImageLink && !val?.imageLink && !linkInvalid) {
        error.imageLink = 'Image Link is required';
        hasError = true;
      }
      if (isVideoLink && !val?.videoLink && !linkInvalid) {
        error.videoLink = 'Video Link is required';
        hasError = true;
      }
      if (isVideoLink && val?.videoLink && !val?.videoLinkType) {
        error.videoLinkType = 'Video type is required';
        hasError = true;
      }

      if (isVideoLink && val?.videoLink && val?.videoLinkType && !linkInvalid) {
        try {
          await getProgressedVideoProperties(val?.videoLink, () => {});
        } catch (err) {
          error.videoLinkType = linkMsg;
          hasError = true;
        }
      }
      newErrors[i] = error;
    };

    const validationPromises = [];

    if (index !== null) {
      const val = damData?.[index];
      if (val) {
        validationPromises.push(validateEntry(val, index));
      }
    } else {
      damData?.forEach((val, i) => {
        validationPromises.push(validateEntry(val, i));
      });
    }

    await Promise.all(validationPromises);

    setErrors(newErrors);
    return { newErrors, hasError };
  };

  const redirectToDamPage = () => {
    history.push('/digital-assets-management');
  };

  const redirectToDamProductPage = () => {
    history.push(`/development-order/${devOrderId}/digital-assets-management`);
  };

  const addUpdateDamLibrary = async () => {
    setLoader(true);
    const validation = await validationFun();
    console.log('validationvalidation', validation);
    console.log('isFolderDragDropisFolderDragDrop', isFolderDragDrop);

    if (!validation?.hasError) {
      const allAssetTitleName = [];
      const requestPayload = damData?.map((val) => {
        allAssetTitleName.push(val.assetTitle);
        return {
          ...val,
          assetType: val?.assetType?.value,
          assignedTo: val?.assignedTo?.map((vl) => vl._id),
          colourTheme: val?.colourTheme?._id,
          primaryColour: val.primaryColour?._id,
          secondaryColour: val.secondaryColour?._id,
          folder: val?.folder?.map((vl) => vl._id),
          videoLinkType: val?.videoLinkType?.value,
        };
      });
      if (allAssetTitleName?.length > 0) {
        const checkExist = await dispatch(dam.checkDamNameExist({ damAssetName: allAssetTitleName, damId }));
        if (checkExist) {
          toasterMsg('Asset title already exist', 'danger');
          setLoader(false);
          return;
        }
      }
      if (isDuplicate && damId) {
        delete requestPayload[0]._id;
        const duplicateFiles = requestPayload[0];
        if (
          duplicateFiles?.imageUrl?.includes(imageLiteral) ||
          duplicateFiles?.croppedImage?.includes(imageLiteral) ||
          duplicateFiles?.videoUrl?.includes(videoLiteral) ||
          duplicateFiles?.videoThumbnail?.includes(imageLiteral)
        ) {
          await dispatch(uploaderAction.uploadSelectedFiles(duplicateFiles, 'DuplicateDAM', t, { extraParams: { damId } }, 'damLibrary'));
        } else {
          duplicateFiles.imageUrl = duplicateFiles.imageUrl ? extractS3KeyName(duplicateFiles.imageUrl, 'DAM') : '';
          duplicateFiles.croppedImage = duplicateFiles.croppedImage ? extractS3KeyName(duplicateFiles.croppedImage, 'DAM') : '';
          duplicateFiles.videoUrl = duplicateFiles.videoUrl ? extractS3KeyName(duplicateFiles.videoUrl, 'DAM_VIDEO') : '';
          if (!includesAnyVideoUrlLink(duplicateFiles.videoThumbnail)) {
            duplicateFiles.videoThumbnail = duplicateFiles.videoThumbnail ? extractS3KeyName(duplicateFiles.videoThumbnail, 'DAM_VIDEO') : '';
          }
          await dispatch(dam.duplicateDamFile(duplicateFiles, damId, t));
        }
        redirectToDamPage();
      } else if (damId) {
        const updateFiles = requestPayload[0];
        updateFiles._id = damId;
        if (
          updateFiles?.imageUrl?.includes(imageLiteral) ||
          updateFiles?.croppedImage?.includes(imageLiteral) ||
          updateFiles?.videoUrl?.includes(videoLiteral) ||
          updateFiles?.videoThumbnail?.includes(imageLiteral)
        ) {
          await dispatch(uploaderAction.uploadSelectedFiles(updateFiles, 'EditDAM', t, null, 'damLibrary'));
        } else {
          updateFiles.imageUrl = updateFiles.imageUrl ? extractS3KeyName(updateFiles.imageUrl, 'DAM') : '';
          updateFiles.croppedImage = updateFiles.croppedImage ? extractS3KeyName(updateFiles.croppedImage, 'DAM') : '';
          updateFiles.videoUrl = updateFiles.videoUrl ? extractS3KeyName(updateFiles.videoUrl, 'DAM_VIDEO') : '';
          if (!includesAnyVideoUrlLink(updateFiles.videoThumbnail)) {
            updateFiles.videoThumbnail = updateFiles.videoThumbnail ? extractS3KeyName(updateFiles.videoThumbnail, 'DAM_VIDEO') : '';
          }
          await dispatch(dam.updateDamFiles(updateFiles, t));
        }
        redirectToDamPage();
      } else {
        const filterPayloadbasedOnBase64 = requestPayload?.filter(
          (vl) =>
            vl?.imageUrl?.includes(imageLiteral) ||
            vl?.croppedImage?.includes(imageLiteral) ||
            vl?.videoUrl?.includes(videoLiteral) ||
            vl?.videoThumbnail?.includes(imageLiteral),
        );
        if (filterPayloadbasedOnBase64?.length > 0) {
          filterPayloadbasedOnBase64?.forEach(async (file) => {
            await dispatch(uploaderAction.uploadSelectedFiles(file, 'AddDAM', t, null, 'damLibrary'));
          });
        } else if (requestPayload?.length > 0) {
          await dispatch(dam.saveDamFiles(requestPayload, t));
        }
        redirectToDamPage();
      }
    } else {
      setLoader(false);
      if (isFolderDragDrop) {
        toasterMsg('Please fill the required fields', 'danger');
      }
    }
  };

  const addUpdateDamProduct = async () => {
    setLoader(true);
    const validation = await validationFun();
    if (!validation?.hasError) {
      const productPayload = [];
      const allAssetTitleName = [];

      for (const dam of damData) {
        if (checkArray(dam.assignedTo)) {
          for (const val of dam.assignedTo) {
            const obj = {
              ...dam,
              assetType: dam?.assetType?.value,
              colourTheme: dam?.colourTheme?._id,
              primaryColour: dam.primaryColour?._id,
              secondaryColour: dam.secondaryColour?._id,
              folder: dam?.folder?.map((vl) => vl._id),
              videoLinkType: dam?.videoLinkType?.value,
              devOrderId: typeof val === 'object' ? val?._id : val,
            };
            productPayload.push(obj);
          }
        }
        allAssetTitleName.push(dam.assetTitle);
      }
      if (allAssetTitleName?.length > 0) {
        const checkExist = await dispatch(productDam.checkProductDamNameExist({ damAssetName: allAssetTitleName, damId }, devOrderId));
        if (checkExist) {
          toasterMsg('Asset title already exist', 'danger');
          setLoader(false);
          return;
        }
      }
      if (damId) {
        const updateFiles = productPayload[0];
        updateFiles._id = damId;
        if (
          updateFiles?.imageUrl?.includes(imageLiteral) ||
          updateFiles?.croppedImage?.includes(imageLiteral) ||
          updateFiles?.videoUrl?.includes(videoLiteral) ||
          updateFiles?.videoThumbnail?.includes(imageLiteral)
        ) {
          await dispatch(uploaderAction.uploadSelectedFiles(updateFiles, 'EditDAM', t, null, 'damProduct', devOrderId));
        } else {
          updateFiles.imageUrl = updateFiles.imageUrl ? extractS3KeyName(updateFiles.imageUrl, 'PRODUCT_DAM', devOrderId) : '';
          updateFiles.croppedImage = updateFiles.croppedImage ? extractS3KeyName(updateFiles.croppedImage, 'PRODUCT_DAM', devOrderId) : '';
          updateFiles.videoUrl = updateFiles.videoUrl ? extractS3KeyName(updateFiles.videoUrl, 'PRODUCT_DAM_VIDEO', devOrderId) : '';
          if (!includesAnyVideoUrlLink(updateFiles.videoThumbnail)) {
            updateFiles.videoThumbnail = updateFiles.videoThumbnail ? extractS3KeyName(updateFiles.videoThumbnail, 'PRODUCT_DAM_VIDEO', devOrderId) : '';
          }
          await dispatch(productDam.updateProductDamFiles(updateFiles, devOrderId, t));
        }
        redirectToDamProductPage();
      } else {
        const filterPayloadbasedOnBase64 = productPayload?.filter(
          (vl) =>
            vl?.imageUrl?.includes(imageLiteral) ||
            vl?.croppedImage?.includes(imageLiteral) ||
            vl?.videoUrl?.includes(videoLiteral) ||
            vl?.videoThumbnail?.includes(imageLiteral),
        );
        if (filterPayloadbasedOnBase64?.length > 0) {
          for (const file of filterPayloadbasedOnBase64) {
            await dispatch(uploaderAction.uploadSelectedFiles(file, 'AddDAM', t, null, 'damProduct', devOrderId));
          }
        } else if (productPayload?.length > 0) {
          await dispatch(productDam.saveProductDamFiles(productPayload, devOrderId, t));
        }
        redirectToDamProductPage();
      }
    } else {
      setLoader(false);
      if (isFolderDragDrop) {
        toasterMsg('Please fill the required fields', 'danger');
      }
    }
  };

  if (loader) {
    return <Loader />;
  }
  return (
    <>
      <div className="page-title-filter sticky">
        <div className="title-container d-flex align-items-center">
          <h4 className="title">{t('DAM_MAIN_VIEW.ADD_EDIT_VIEW.PAGE_TITLE')}</h4>
        </div>
        <div className="search-filter">
          {DamAddeditstate?.dam?.[0]?.assetType && (
            <button
              disabled={stateLoader}
              type="button"
              className="btn btn-white btn-back-lib "
              onClick={() => (devOrderId ? addUpdateDamProduct() : addUpdateDamLibrary())}
            >
              {t(damId && !isDuplicateFile ? 'DAM_MAIN_VIEW.ADD_EDIT_VIEW.UPDATE_DAM' : 'DAM_MAIN_VIEW.ADD_EDIT_VIEW.SAVE')}
            </button>
          )}
          <Link
            className="btn btn-white btn-back-lib "
            to={devOrderId ? `/development-order/${devOrderId}/digital-assets-management` : '/digital-assets-management'}
          >
            {t('DAM_MAIN_VIEW.ADD_EDIT_VIEW.BACK')}
          </Link>
        </div>
      </div>
      <Container fluid className="pt-3">
        {!DamAddeditstate?.dam?.[0]?.assetType && !damId && !isFolderDragDrop ? (
          <Row>
            <Col md={2}>
              <div className="custom-react-select">
                <label className="asterisk-req f-13 m-0">
                  {t('DAM_MAIN_VIEW.ADD_EDIT_VIEW.ASSET_TYPE')}
                  <span>*</span>
                </label>
                <Select
                  value={DamAddeditstate?.assetType}
                  options={assetType || []}
                  styles={customStylesProductAddEdit}
                  placeholder="Select asset type"
                  onChange={selectAssetType}
                />
              </div>
            </Col>
          </Row>
        ) : (
          <AddEditDAMComponent errors={errors} validationFun={validationFun} />
        )}
      </Container>
    </>
  );
}

export default AddEditDAM;
